/**
 * Browser-safe access-mode surface. Keep this separate from the server-only
 * auth barrel so client components do not pull in auth persistence.
 */
export { canAccessFullPlatform } from '../access-mode';
